import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import ActionDone from 'material-ui/svg-icons/action/done';
import { accountSubmitORCR as accountSubmitORCRAction } from '../actions/AccountActions'
import { Link } from 'react-router-dom';
import IconButton from 'material-ui/IconButton';

class SubmitORCR extends Component {

	handleSubmitORCR = () => {
		const { accountSubmitORCR, record } = this.props
		accountSubmitORCR(record.id, record)
	}

	render() {
		const { record, basePath } = this.props;
		const { fields } = record
		let button = null

		if ( ['review', 'booking', 'for_collection', 'proceeds_collected'].indexOf( fields.status ) !== -1 ) {
			if ( fields.or__cr_submission_date ) {
				button = (
					<IconButton
						containerElement={<Link to={`${basePath}/${record.id}`} />}
				        style={{ overflow: 'inherit' }}
				    >
				        <ActionDone color="#0277bd" />
				    </IconButton>
				)
			} else {
				button = (
					<FlatButton
						label="Submit OR/CR"
						primary={true}
						onClick={this.handleSubmitORCR}
					/>
				)
			}
		} else if ( fields.status === 'di_collected' ) {
			if ( ! fields.or__cr_submission_date ) {
				button = (
					<FlatButton
						label="Submit OR/CR"
						primary={true}
						onClick={this.handleSubmitORCR}
					/>
				)
			} else {
				button = <ActionDone color="#0277bd" />
			}
		} else { // Uneditable.
			if ( fields.or__cr_submission_date ) {
		        button = <ActionDone color="#0277bd" />
			}
		}

		return button
	}
}

SubmitORCR.propTypes = {
	basePath: PropTypes.string,
	label: PropTypes.string,
    record: PropTypes.object,
	accountSubmitORCR: PropTypes.func,
};

SubmitORCR.defaultProps = { label: 'OR/CR' };

export default connect(null, {
	accountSubmitORCR: accountSubmitORCRAction,
})(SubmitORCR);



// WEBPACK FOOTER //
// ./src/CollectorAccount/SubmitORCR.js